import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/quality';

const options = {
  cache: {
      maxAge: 24 * 60 * 60 * 1000,
      exclude: { query: false }
  }
}

const loadQualities = async ({ quality_ids }) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, { quality_ids });
  return api.get(url, options);
}

export {
  loadQualities,
}
